import  { FC } from "react";
import FlightSearch from "@components/flightSearch/FlightSearch";

interface IFlightSearchTabPanelProps { }

const FlightSearchTabPanel: FC<IFlightSearchTabPanelProps> = () => {

    return (
        <div className="flight-search-tab-panel">
            <FlightSearch tabPanelMode />
        </div>
    );
}

export default FlightSearchTabPanel;